import { CheckGuidesGenerated } from 'domain/usecases/surgical-order/check-guides-generated'
import { SurgicalOrderRepository } from 'repository/repositories/surgical-order/surgical-order-repository'

export class RemoteCheckGuidesGenerated implements CheckGuidesGenerated {
  constructor(
    private readonly surgicalOrderRepository: SurgicalOrderRepository
  ) {}

  check(
    params: CheckGuidesGenerated.Params
  ): Promise<CheckGuidesGenerated.Model> {
    return this.surgicalOrderRepository.checkGuidesGenerated(params)
  }
}
